import {
  Box,
  CssBaseline,
  Theme,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material'
import DashboardAppBar from '../components/layouts/dashboard/DashboardAppBar'
import DashboardDrawer, {
  drawerWidth,
} from '../components/layouts/dashboard/DashboardDrawer'

import FormSelect from '../components/FormSelect'
import ProductsTable from '../components/table/ProductsTable'
import { useFormContext } from '../context/form'
import { useDrawerStore } from '../store/useDrawerStore'
import './Dashboard.scss'

const Dashboard = ({ apiKey }: { apiKey: string }) => {
  const { form } = useFormContext()
  const theme: Theme & { custom: any } = useTheme()
  const { isDrawerOpen } = useDrawerStore()

  const isMaxHeightApplicable =
    apiKey === '60f020d0-aa94-4c03-a945-268924f85b4a'
      ? {}
      : { maxHeight: '100vh' }

  const renderSort = () => {
    return (
      <Box
        padding="10px"
        minHeight="75px"
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: '#e6e6e6',
          boxShadow: '0 2px 1px rgba(0, 0, 0, 0.15)',
        }}
      >
        <Typography
          // color="primary"
          width="120px"
          variant="body1"
          component="span"
          fontWeight={700}
          fontSize={{
            md: '14px !important',
            xs: '12px !important',
          }}
        >
          Sorted By:
        </Typography>
        <FormSelect
          variant="outlined"
          name="sortedBy"
          control={form.control}
          label=""
          sx={{
            mb: '0 !important',
          }}
          items={[
            {
              label: 'Initial Rate',
              value: 'InitialPayRate',
            },
            {
              label: 'Monthly Cost',
              value: 'InitialMonthlyPayment',
            },
            {
              label: 'Initial Term Cost',
              value: 'TrueCostOverInitialPeriod',
            },
            {
              label: 'APRC',
              value: 'AprLenders',
            },
          ]}
        />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <CssBaseline />
      <DashboardAppBar />
      {theme?.custom?.appConfig?.showMenuBar === 'Yes' ? (
        <DashboardDrawer />
      ) : null}
      <Box
        component="main"
        display="flex"
        flexDirection="column"
        sx={{
          flexGrow: 1,
          minHeight: '100vh',
          ...isMaxHeightApplicable,
          overflow: 'hidden',
          ...(theme?.custom?.appConfig?.showMenuBar === 'Yes'
            ? {
                marginLeft: {
                  md: isDrawerOpen ? `${drawerWidth}px` : '0px',
                },
              }
            : {}),
        }}
      >
        <Toolbar />
        {theme?.custom?.appConfig?.showDropdownMenu === 'Yes'
          ? renderSort()
          : null}
        <ProductsTable />
      </Box>
    </Box>
  )
}

export default Dashboard
